import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.states';
import { Observable, of } from 'rxjs';
import { loadUserHistoryPredictions } from '../store/actions/prediction.actions';
import { loadUserCredits } from '../store/actions/credits.actions';

export const historyGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const store = inject(Store<AppState>);
  const userId = JSON.parse(localStorage.getItem('user') || '{}').user_id;
  if (!userId) return of(false);
  
  store.dispatch(loadUserHistoryPredictions({ userId: userId }));
   store.dispatch(loadUserCredits({ userId:userId }));
  
  return of(true);
};